import { render, staticRenderFns } from "./IndexAsideStatic.vue?vue&type=template&id=62b593ae&scoped=true"
import script from "./IndexAsideStatic.vue?vue&type=script&lang=js"
export * from "./IndexAsideStatic.vue?vue&type=script&lang=js"
import style0 from "./IndexAsideStatic.vue?vue&type=style&index=0&id=62b593ae&prod&lang=scss&scoped=true"
import style1 from "./IndexAsideStatic.vue?vue&type=style&index=1&id=62b593ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b593ae",
  null
  
)

export default component.exports